export default "<p class=\"result\">You feel <span>{{emotion}}</span> because <span>{{reason.reason}}.</span></p>\r\n\r\n"